import { render, staticRenderFns } from "./ListingImportedHorses.vue?vue&type=template&id=99940564&"
import script from "./ListingImportedHorses.vue?vue&type=script&lang=js&"
export * from "./ListingImportedHorses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports